
        import Symbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "bfd3f1",
  "use": "bfd3f1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"bfd3f1\"><path d=\"M22 4.35a2.35 2.35 0 0 0-1.451-2.171 2.35 2.35 0 0 0-2.561.51l-1.23 1.228.894.893a.505.505 0 0 1-.715.715l-.893-.893-2.317 2.317.893.893a.505.505 0 0 1 0 .715.505.505 0 0 1-.715 0l-.893-.893-2.317 2.317.893.893a.505.505 0 0 1-.714.714l-.893-.893-2.317 2.318.892.892a.505.505 0 0 1 0 .715.505.505 0 0 1-.714 0l-.893-.893-2.317 2.317.893.893a.505.505 0 0 1-.715.715l-.893-.893-1.229 1.229A2.35 2.35 0 0 0 4.35 22h15.3a2.35 2.35 0 0 0 1.662-.688A2.35 2.35 0 0 0 22 19.65ZM17.3 17.3h-7.276l7.275-7.276z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#bfd3f1"/>
                </svg>
            );
        };

        Icon.id = "bfd3f1";

        export default Icon;
    